import { useCommands } from '@remirror/react';
import { useCallback } from 'react';

const imageAttributeCreatorFromURI = (url) => ({ src: url, alt: '' });

export function useDirectLinkUpload() {
  const { uploadImage, addYouTubeVideo } = useCommands();

  const upload = useCallback(
    ({ src, onFinish }) => {
      try {
        const url = new URL(src);
        if (url.host === 'www.youtube.com') {
          const videoId = url.searchParams.get('v');
          addYouTubeVideo({ video: videoId });
          onFinish(null);
        } else {
          fetch(src)
            .then((res) => {
              const contentType = res.headers.get('Content-Type').split('/')[0];
              if (res.ok && (contentType === 'image' || contentType === 'binary')) {
                uploadImage(function () {
                  return Promise.resolve(imageAttributeCreatorFromURI(src));
                });
              }
              onFinish?.(null);
            })
            .catch(() => onFinish(new Error('Unable to upload media. Please try again!')));
        }
      } catch (err) {
        onFinish(new Error('Please provide a valid media url.'));
      }
    },
    [uploadImage, addYouTubeVideo]
  );

  return upload;
}

export default useDirectLinkUpload;
